import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  editorContainer: css`
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 14px;
  `,
  editorWrapper: css`
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  `,
  message: css`
    padding-bottom: 24px;
  `,
  toolbar: css`
    padding: 0 8px 8px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
